<div>


  <div class="nav-under container-fluid header-borders border-bottom py-2">
    <nav aria-label="breadcrumb" class="row">
      <div class="col-md-10">
        <ol class="breadcrumb bg-white page-title" style="margin-bottom: 0;">
          <li class="breadcrumb-item ">App Content</li>
          <li class="breadcrumb-item active" aria-current="page">Animals</li>
        </ol>
      </div>
      <div class="col" *ngIf="countryName === 'India'">
        <select
          id="language"
          class="form-control mt-1 lang-select"
          (change)='onLanguageSelected($event)'
          style="width: 70%;"
          name="language"
        >
          <option *ngFor="let language of languages" [value]="language">{{language}}</option>
        </select>
      </div>
    </nav>
  </div>

  <div class="dash-section" >
    <div class="py-3 border-bottom mb-3">
      <div class="mx-0 row">
        <div class="col-6 col-md">
          <span class="btn float-left">
            All animals ({{ animalCount }})
          </span>
          <button
          class="btn btn-primary"
          data-toggle="modal"
          data-target="#addAnimalModal"
          >
            Add an animal
          </button>
        </div>
        <div class="col-6 col-md-auto">
          <div class="searchbox">
          <input
            type="text"
            class="form-control"
            placeholder="search by name"
            id="searchAnimal"
            (keyup)="filterAnimalFunction()"
          >
          <span class="fa fa-search"></span>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row" >
        <div class="col-6 col-lg-2" *ngFor="let animalItem of filteredAnimals">
          <a
            (click)="getProductDetails(animalItem.animal, selectedLanguage)"
            class="btn btn-lite btn-block text-left"
          >
          <img src="https://img.icons8.com/fluent/48/000000/folder-invoices.png"/>
          {{animalItem.animal}}</a>
        </div>
      </div>
      <div class="spinner d-flex" *ngIf="isLoadingAnimals">
        <span class="spinner-border spinner-border-md mx-auto update-loading" role="status"></span>
      </div>
    </div>
  </div>
</div>

<!-- Add animal modal -->
<div class="modal fade" id="addAnimalModal">
  <div class="modal-dialog modal-dialog-centered" role="document"
    style="max-width: 50%;" (click)="onClickOutside()">
    <div class="card modal-content container-fluid">
        <div class="container-fluid">
          <form
            #createAnimalForm="ngForm"
            class="py-2"
            id="animalForm"
          >
            <div class="modal-header head no-border">
              <h5 class="modal-title text bold text-primary" id="modal-basic-title">Add animal</h5>
              <select
                *ngIf="countryName==='India'"
                id="language"
                name="language"
                #language="ngModel"
                ngModel
                class="form-control mt-1 lang-select"
                (change)='onLanguageChosen($event)'
                style="width: 40%; margin-left: 250px"
                required
              >
                <option hidden disabled selected value> -- select a language -- </option>
                <option *ngFor="let language of languages" [value]="language">{{language}}</option>
              </select>
              <button
                type="button"
                class="close close-btn"
                data-dismiss="modal"
                aria-label="Close"
                (click)="resetAddAnimalModal()"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body p-0 agronomical-view-details" *ngIf="!createAnimalIsSuccess">
              <span class="text-center alert alert-danger" *ngIf="createAnimalError">{{ message }}</span>
                <div class="form-group">
                  <label>Animals</label>
                  <input
                    type="text"
                    class="form-control"
                    name="animals"
                    ngModel
                    #animals="ngModel"
                    required
                  />
                  <div
                    *ngIf="animals.dirty || (animals.touched && !animals.valid)"
                    class="text-danger error_message"
                  >
                    <span *ngIf="animals.hasError('required')">
                      Please the animal name is required
                    </span>
                  </div>
                </div>

                <div class="form-group">
                  <label>About</label>
                  <quill-editor
                    name="description"
                    #description="ngModel"
                    [(ngModel)]="animalDescription"
                    [modules]="quillConfig"
                    [styles]="editorStyle"
                  >
                  </quill-editor>
                </div>

                <div class="form-group">
                  <label>Image</label>
                  <input
                    type="file"
                    class="form-control file-input"
                    id="animalPhoto"
                    name="photo"
                    (change)="processImage($event)"
                    accept="image/*"
                  />
                </div>
            </div>
          <div class="modal-footer no-border" *ngIf="!createAnimalIsSuccess">
            <a class="btn btn-secondary" data-dismiss="modal" (click)="resetAddAnimalModal()">
              <span class="text-white">Cancel</span>
            </a>
            <div class="d-flex justify-content-center align-item-center form-group mb-0">
              <button
                type="button"
                (click)="createAnimal(createAnimalForm.value)"
                class="submit-animal-btn btn btn-primary"
                [disabled]="!createAnimalForm.form.valid"
              >
                <span
                  *ngIf="loading"
                  class="spinner-border spinner-border-sm"
                  role="status"  aria-hidden="true"
                >
                </span>
                <span *ngIf="loading" class="mx-2">Loading...</span>
                <span *ngIf="!loading">
                  Add Animal
                </span>
              </button>
            </div>
          </div>
          </form>
        </div>
    </div>
  </div>
</div>
